import { createSelector } from 'reselect';
import { PreviewId } from '../../library/App';
import { entitiesSelector } from '../App/selectors';

export const previewDetailSelector = (previewId: PreviewId) =>
  createSelector(entitiesSelector, (entities) =>
    previewId in entities.previews ? entities.previews[previewId] : null,
  );
